import { useMemo } from "react"
import { useFeatureFlagEnabled } from "posthog-js/react"
import { useAppSelector } from "../reducers/hooks"
import { selectAccountChats } from "../reducers/accountChatsSlice"
import {
  buildIsSlickAISilenced,
  SILENT_SLICK_AI_FLAG,
} from "../lib/slickAISilence"

/**
 * The reactive half of `buildIsSlickAISilenced` — see `lib/slickAISilence.ts`
 * for the rule. Selectors and thunks read the flag imperatively instead.
 *
 * Returns a stable predicate: `(chatJid) => boolean`.
 */
const useSlickAISilencePredicate = () => {
  const flagEnabled = Boolean(useFeatureFlagEnabled(SILENT_SLICK_AI_FLAG))
  const accountChats = useAppSelector(selectAccountChats)

  return useMemo(
    () => buildIsSlickAISilenced(flagEnabled, accountChats),
    [flagEnabled, accountChats],
  )
}

export default useSlickAISilencePredicate
